"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _BaseClass2 = require("./BaseClass");

var _BaseClass3 = _interopRequireDefault(_BaseClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Customer = function (_BaseClass) {
  _inherits(Customer, _BaseClass);

  /**
   * KundenId
   * @type {string}
   */

  /**
   * Id des Mandanten
   * @type {string}
   */

  /**
   * Anrede
   * @type {string}
   */

  /**
   * Nachname
   * @type {string}
   */

  /**
   * Vorname
   * @type {string}
   */

  /**
   * Adresszusatz
   * @type {string}
   */

  /**
   * Geburtsdatum
   * @type {date}
   */

  /**
   * Straße
   * @type {string}
   */

  /**
   * Hausnummer
   * @type {string}
   */

  /**
   * Hausnummerzusatz
   * @type {string}
   */

  /**
   * PLZ
   * @type {string}
   */

  /**
   * Ort
   * @type {string}
   */

  /**
   * Kundennummer
   * @type {string}
   */

  /**
   * Email
   * @type {string}
   */

  /**
   * Telefonnummer
   * @type {string}
   */

  /**
   * Telefonnummer 2 (meist geschäftlich)
   * @type {string}
   */

  /**
   * Faxnummer
   * @type {string}
   */

  /**
   * Geschlecht
   * @type {string}
   */

  /**
   * Klasse (z.B. a,b)
   * @type {string}
   */

  /**
   * Klassenstufe (z.N. 2)
   * @type {integer}
   */

  /**
   * Land
   * @type {string}
   */

  /**
   * Titel
   * @type {string}
   */

  /**
   * Registrierungscode
   * @type {string}
   */

  /**
   * Marketing per Post erlaubt
   * @type {boolean}
   */

  /**
   * Marketing per Email erlaubt
   * @type {boolean}
   */

  /**
   * Marketing per Telefon erlaubt
   * @type {boolean}
   */

  /**
   * Marktforschung erlaubt
   * @type {boolean}
   */

  /**
   * Kunde möchte keine Email bei Vertragsänderungen erhalten
   * @type {boolean}
   */

  /**
   * Kundenkategorie (z.B. Abo)
   * @type {array} of strings
   */
  function Customer() {
    _classCallCheck(this, Customer);

    var _this = _possibleConstructorReturn(this, (Customer.__proto__ || Object.getPrototypeOf(Customer)).call(this));

    _this.Id = "";
    _this.ClientId = "";
    _this.Salutation = "";
    _this.Name1 = "";
    _this.Name2 = "";
    _this.Name3 = "";
    _this.DateOfBirth = "";
    _this.Street = "";
    _this.HouseNumber = "";
    _this.HouseNumberAddition = "";
    _this.PostCode = "";
    _this.City = "";
    _this.CustomerNumber = "";
    _this.Email = "";
    _this.Phone = "";
    _this.Phone2 = "";
    _this.Fax = "";
    _this.Gender = "";
    _this.Class = "";
    _this.GradeLevel = 0;
    _this.Country = "";
    _this.Title = "";
    _this.RegNr = "";
    _this.MarketingPost = false;
    _this.MarketingEmail = false;
    _this.MarketingPhone = false;
    _this.FlagMarketing = false;
    _this.NoMail = false;
    _this.CustomerCategory = [];
    _this.Zusatz2 = "";

    return _this;
  }
  /**
   * Kommentarfeld
   * @type {string}
   */


  return Customer;
}(_BaseClass3.default);

exports.default = Customer;